import axios from 'axios';
import { devEnv, PARTNER_MGMT_USER_FEEDBACK_API_URL } from 'services/constants';
import UserFeedback from 'types/UserFeedback';

const axiosInstance = axios.create({ withCredentials: devEnv });
export const CONTENT_TYPE_JSON = 'application/json';

/**
 * Call the pcm-prospect-frontend-controller to create a new user feedback
 */
const createUserFeedback = async (newFeedback: UserFeedback) => {
  const request = axiosInstance.post(`${PARTNER_MGMT_USER_FEEDBACK_API_URL}`, JSON.stringify(newFeedback), {
    headers: {
      'Content-Type': CONTENT_TYPE_JSON,
    },
  });
  const response = await request;
  return response;
};

const userFeedbackService = { createUserFeedback };
export default userFeedbackService;
